import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';
import { indexedDBStorage } from './indexedDBStorage';

/**
 * When refreshing (localhost only), it will just log the space that's there at the moment (assuming you're using session storage).
 * In Development only (locally).
 */
export async function logPersistStats() {
    if (process.env.NODE_ENV !== "development") {
        return;
    }

    const value = await indexedDBStorage.getItem(
        "REACT_QUERY_OFFLINE_CACHE"
    );

    if (!value) {
        return;
    }

    const cache = JSON.parse(value);

    console.log("React Query Persist", {
        size: ((value.length * 2) / 1024).toFixed(2) + " KB",
        queries: cache.clientState.queries.length
    });
}

export const appQueryPersister = createAsyncStoragePersister({
    storage: indexedDBStorage
});
